/* STONEBERRY developer override layer. Kept intentionally empty. */


document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-sms-blackjack-trigger]');
  if (!trigger) return;
  document.dispatchEvent(new CustomEvent('stoneberry:sms-blackjack:open', { bubbles: true }));
  var commonTrigger = document.querySelector('[data-postscript-popup-trigger], [data-sms-popup-open], .postscript-popup-trigger');
  if (commonTrigger && commonTrigger !== trigger) commonTrigger.click();
});

// STONEBERRY v2.7.0 — checkout Complete Your Look handled only by the Checkout UI extension at ORDER_SUMMARY4; no storefront checkout interception.
